<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>

    <v-card-title>
      Investigation
      <v-spacer></v-spacer>

      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Select Date"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu2 = false"
            @click:date="dateSelect"
            :max="nowDate"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="desserts"
      class="elevation-1"
      :search="search"
      :actions="actions"
      dense
      mobile-breakpoint="0"
      :loading="loadingstatus"
      loading-text="Loading... Please wait"
    >
      <template v-slot:item.status="{ item }">
        <v-chip :color="getColor(item.status)" dark>
          {{ item.status }}
        </v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              @click="invoice_print(item)"
              dark
              v-bind="attrs"
              v-on="on"
              class="ma-2"
              open
              color="primary"
              outlined
            >
              <v-icon left> mdi-printer </v-icon>
            </v-chip>
          </template>
          <span>Invoice Print</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              @click="invoice_edit(item)"
              dark
              v-bind="attrs"
              v-on="on"
              class="ma-2"
              open
              color="primary"
              outlined
            >
              <v-icon left> mdi-pencil </v-icon>
            </v-chip>
          </template>
          <span>Invoice Edit</span>
        </v-tooltip>
      </template>

      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      loadingstatus: true,
      returnUrl: atshq.defaults.headers.common.app_URL,
      search: "",
      headers: [
        { text: "Invoice ID", value: "invoice_id" },
        {
          text: "Investigation Name",
          sortable: true,
          value: "invoice_description",
        },
        { text: "Eye", value: "invoice_eye_type" },
        { text: "Incharge", value: "incharge.full_name" },
        { text: "Report Doctor", value: "report_doctor.dr_name" },
        { text: "Status", value: "status" },
        { text: "Action", value: "actions", sortable: false },
      ],
      desserts: [],
      actions: [
        {
          type: "edit",
          key: ["Description"],
          func: this.updatePayment,
          icon: "edit",
        },
      ],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoices",
          disabled: true,
          href: "Invoices",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date);
  },
  methods: {
    initialize(date) {
      atshq
        .get("investigations/investigation-data?date=" + date)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.loadingstatus = false;
          this.desserts = response.data.data;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    getColor(status) {
      if (status == "void") return "red";
      else return "green";
    },
    invoice_print(item) {
      window.open(
        this.returnUrl + "printdoc/invoice/" + item.invoice_id + "/1"
      );
    },
    invoice_edit(item) {
      window.location.href = "/investigations/edit/" + item.id;
    },

    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
  },
};
</script>